export default __webpack_public_path__ + "static/media/entenda_b_carpado.4c8b9ed3.jpg";